import index from './index.vue';

export default index;


// WEBPACK FOOTER //
// ./src/vue/components/plugIn/dialog/index.js